import { render, staticRenderFns } from "./HistoricalData.vue?vue&type=template&id=51a29dda&scoped=true"
import script from "./HistoricalData.vue?vue&type=script&lang=js"
export * from "./HistoricalData.vue?vue&type=script&lang=js"
import style0 from "./HistoricalData.vue?vue&type=style&index=0&id=51a29dda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a29dda",
  null
  
)

export default component.exports